import { FeatureFlagDto } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagDto";
import { EventBus } from "./EventBus";
import EventConstants from "./EventConstants";
import { ServicesFactoryInstance } from "./ServicesFactory";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { FeatureFlagUpdateDto } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagUpdateDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

export interface IFeatureFlagMapped {
	id: number,
	isActive: boolean,
	title: string
}

export class FeatureFlagManager {
	public listeFeatureFlag: FeatureFlagDto[] = [];

	public constructor() {
		// Recharge la liste des feature flags lorsque l'utilisateur est connecté
		EventBus.$on(EventConstants.CONNECTED, () => this.getListeFeatureFlag());
	}

	/**
	 * Récupère la liste des feature flags.
	 * @param societe Société courante
	 */
	public getListeFeatureFlag(): void {
		ServicesFactoryInstance.FeatureFlagService.getListeFeatureFlag(
			(data) => {
				this.listeFeatureFlag = data;
				EventBus.$emit(EventConstants.FEATURE_FLAG_LOADED);
			},
			() => {
				this.listeFeatureFlag = [];
				EventBus.$emit(EventConstants.FEATURE_FLAG_LOADED);
			}
		);
	}

	/**
	 * Met à jour la liste des feature flags.
	 * @param featureFlag Liste des feature flags à mettre à jour
	 * @returns Promise indiquant le succès ou l'échec de l'opération
	 */
	public async updateFeatureFlag(featureFlag: IFeatureFlagMapped[]): Promise<boolean> {
		const updateList: FeatureFlagUpdateDto[] = featureFlag.map((flag) => ({
			Id: flag.id,
			EstActive: flag.isActive
		}));

		return new Promise<boolean>((resolve) => {
			ServicesFactoryInstance.FeatureFlagService.updateListeFeatureFlag(updateList, (data) => {
				this.listeFeatureFlag = data;
				NotificationServiceInstance.SendSuccess("La mise à jour des feature flag s'est correctement déroulée !");
				resolve(true);
			}, () => {
				NotificationServiceInstance.SendFailed("Une erreur est survenue lors de la mise à jour de la liste des feature flag.");
				resolve(false);
			});
		});
	}

	/**
	 * Vérifie si un feature flag est actif.
	 * @param featureFlag Module à vérifier
	 * @returns true si le feature flag est actif, false sinon
	 */
	public hasFeatureFlag(featureFlag: FeatureFlagModuleEnum): boolean {
		return this.listeFeatureFlag != undefined && this.listeFeatureFlag.filter(f => f.Module == featureFlag && f.EstActive == true).length > 0;
	}
}

export const FeatureFlagManagerInstance: FeatureFlagManager = new FeatureFlagManager();



// WEBPACK FOOTER //
// ./src/components/Controls/FeatureFlagManager.ts